import type { ReactElement } from 'react';
import { Tooltip } from '@mui/material';
import { useTranslation } from 'react-i18next';

/**
 * A card action as a non-OWNER sees it (PERM-002): the caller renders it disabled, and this wraps
 * it in the "Only an owner can change the card" tooltip (a disabled button fires no events, hence
 * the `span`). An OWNER gets the action as is.
 */
export function OwnerOnlyAction({
  isOwner,
  children,
}: {
  isOwner: boolean;
  children: ReactElement;
}) {
  const { t } = useTranslation();
  if (isOwner) return children;
  return (
    <Tooltip title={t('resellerBilling.ownerOnly')}>
      <span>{children}</span>
    </Tooltip>
  );
}
